'use strict';

var FirebaseCalendarInstances = function FirebaseCalendarInstances() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'FIREBASE_CALENDARS_UPDATE_VALUE':
      {
        // Updating something else inside Calendars
        if (action.label.indexOf('instances') === -1) {
          return state;
        }

        // Build combined Id
        var calendarId = action.id;
        var dateStr = action.label.substring('instances/'.length);
        var combinedId = calendarId + '->' + dateStr;

        // Set the new value
        var newState = Object.assign({}, state);
        newState[combinedId] = action.value;
        return newState;
      }

    default:
      return state;
  }
};

module.exports = FirebaseCalendarInstances;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/clients/reducers/FirebaseCalendarInstances.js
// module id = 1020
// module chunks = 0